import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
// Remove the useHistory import as it's not available in React Router v6.
// If navigation is needed, you can import useNavigate like this:
// import { useNavigate } from 'react-router-dom';

const CookieBanner = () => {
  const [open, setOpen] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  // If navigation is required, you can initialize it:
  // const navigate = useNavigate();

  // Check if the user has already provided consent on component mount.
  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setOpen(true);
    }
  }, []);

  // Handler for "Accept All" option.
  const handleAcceptAll = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SOCKET_SERVER_URL}/generate_customer`, { method: 'GET' });
      const data = await response.json();
      const cookieId = data.external_id;
      localStorage.setItem('cookieConsent', JSON.stringify({ level: 'all', id: cookieId }));
      setOpen(false);
    } catch (error) {
      console.error('Error while accepting all cookies:', error);
    }
  };

  // Handler for "Accept Only Required" option.
  const handleAcceptRequired = () => {
    localStorage.setItem('cookieConsent', JSON.stringify({ level: 'required' }));
    setOpen(false);
  };

  // Toggle to show detailed cookie information.
  const handleShowInfo = () => {
    setShowInfo(true);
  };

  const handleCloseInfo = () => {
    setShowInfo(false);
  };

  return (
    <>
      {open && (
        <Box
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            bgcolor: 'background.paper',
            boxShadow: 3,
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            zIndex: 1300,
            borderTop: '1px solid',
            borderColor: 'secondary.main', // added top border
          }}
        >
          <Typography variant="body1" align="center">
            We use cookies to enhance your experience. In order to get the full experience of the website, please accept all cookies. It especially important if you would like to have demo of the full functionality.
          </Typography>
          <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
            <Button variant="outlined" onClick={handleAcceptRequired}>
                Only Required
            </Button>
            <Button variant="contained" color="primary" onClick={handleAcceptAll}>
                Accept All
            </Button>
          </Box>
          <Button onClick={handleShowInfo} sx={{ mt: 1 }}>
            More Info
          </Button>
        </Box>
      )}

      <Dialog open={showInfo} onClose={handleCloseInfo}>
        <DialogTitle>Cookie Information</DialogTitle>
        <DialogContent>
          <Typography variant="body2">
            Here you can provide more detailed information about how and why cookies are used on the site,
            what data is collected, and how it enhances user experience.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseInfo}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CookieBanner;